import * as React from "react";
import CustomRoutesConfig from "./routes/customRoutesConfig";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import "./App.css";

// Create a default theme
const theme = createTheme();

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />  {/* Resets default browser styles */}
      <div className="App">
        <CustomRoutesConfig />
        
      </div>
    </ThemeProvider>
  );
}

export default App;
